import React from "react";
import HomeComponent from "./components/home/HomeComponent";
import PricingComponent from "./components/pricing/PricingComponent";
import CitiesComponent from "./components/cities/CitiesComponent";
import ReviewsComponent from "./components/reviews/ReviewsComponent";
import ContactDetails from "./components/contact/ContactDetails";
import WriteReview from "./components/reviews/WriteReview";

const Home = () => {
  return (
    <div>
      <HomeComponent />
      <WriteReview />
      <PricingComponent />
      <CitiesComponent />
      <ReviewsComponent />
      <ContactDetails />
    </div>
  );
};

export default Home;
